import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE_CAMPAIGN_LIST = {
  'list': [],
  'loading': false,
};

export const campaignList = (state, action) => {
  return createReducer(INITIAL_STATE_CAMPAIGN_LIST, {
    [ActionTypes.FETCHING_CAMPAIGNS_LIST]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_CAMPAIGNS_LIST]: (state, action) => ({
      ...state,
      'loading': false,
      'list': action.response.data,
    }),
    [ActionTypes.FETCHED_CAMPAIGNS_LIST_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'list': [],
    }),
    [ActionTypes.CLEAR_CAMPAIGNS_LIST]: (state, action) => ({
      ...state,
      'loading': false,
      'list': [],
    }),
  })(state, action);
};
